/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
export const RESTIFY_MW_METHODS = ['use', 'pre'];
export const RESTIFY_METHODS = [
  'del',
  'get',
  'head',
  'opts',
  'post',
  'put',
  'patch',
];
export const MODULE_NAME = 'restify';
